import { ChevronRight } from 'src/components/Icons/ChevronRight'

interface ManageAddressesSheetHeaderProps {
  onBack?: () => void
}

export function ManageAddressesSheetHeader({
  onBack,
}: ManageAddressesSheetHeaderProps) {
  return (
    <div className="px-6 pt-5 pb-5 md:pt-6">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          aria-label="Voltar para seleção de endereço"
          data-testid="manage-addresses-back-button"
          className="flex items-center gap-1 mb-3 text-font-size-2 font-semibold text-restructure-action"
        >
          <ChevronRight width={14} height={14} className="rotate-180" />
          <span>Voltar</span>
        </button>
      )}
      <p className="text-font-size-6 leading-tight font-bold text-restructure-primary font-display tracking-[-0.5px]">
        Gerenciar endereços
      </p>
      <p className="mt-[5px] text-sm text-postal-muted leading-snug font-normal">
        Edite, exclua ou defina um endereço como padrão de entrega.
      </p>
    </div>
  )
}
